export const actionDatesTableColumns = [
  {
    prop: 'name',
    title: 'common.fields.name',
    width: '25%',
    sortingEnabled: true,
  },
  {
    prop: 'description',
    title: 'common.fields.description',
    width: '67%',
    sortingEnabled: true,
  },
  {
    prop: 'actions',
    title: 'common.fields.actions',
    width: '8%',
    sortingEnabled: false,
  },
];
